import axios from 'axios';
import assign from 'object-assign';
import cookies from 'js-cookie';
import qs from 'qs';

const request = axios.create({
    withCredentials: false,
    timeout: 600000,
    headers: {
        'content-type': 'application/x-www-form-urlencoded',
    },
});

request.interceptors.request.use((config) => {
    const reDefineConfig = assign({}, config);
    const {
        method,
        isJSon,
        responseType,
        isUrlRest,
    } = reDefineConfig;
    let token=null ;
    
    if(config.url.indexOf("system/sysUser/login")!==-1){
  
    }else{
        token=   localStorage.getItem('token') || '';
        reDefineConfig.headers.token = token;
    }
    if(config.isUrlRest){
        reDefineConfig.url=config.url+location.href.split("/")[location.href.split("/").length-1]

    }
  
    
    if (isJSon) {
        reDefineConfig.headers['content-type'] = 'application/json;charset=UTF-8';
    }
    reDefineConfig.headers['tenantId'] = '15';
    console.log("----------------请求地址",config)



    reDefineConfig.data = reDefineConfig.data || {};
    reDefineConfig.params = reDefineConfig.params || {};

    if (String(method).toUpperCase() === 'GET') {
        const obj = {};
        for (const i in reDefineConfig.params) {
            const str = reDefineConfig.params[i];
            obj[i] = (typeof str === 'string') ? str.trim() : str;
        }

        reDefineConfig.params = assign(obj, {
            // schoolId,
            timestamp: new Date().getTime(), // hack get 请求被缓存的问题
        });
    } else {
        const obj = {};
        for (const i in reDefineConfig.data) {
            const str = reDefineConfig.data[i];
            obj[i] = (typeof str === 'string') ? str.trim() : str;
        }

        if (isJSon) {
            console.log("发送数据", obj)
                //reDefineConfig.data = obj;
        } else {
            reDefineConfig.data = qs.stringify(assign(obj, {
                // schoolId,
                timestamp: new Date().getTime(),
            }));
        }
    }

    console.log("----------------最终返回-------------",reDefineConfig)
    return reDefineConfig;
}, (error) => Promise.reject(error));

function checkResponse(response) {
    const {
        data: {
            success,
            message,
        },
        status,
        config: {
            url,
        },
    } = response;
    const errorCb = () => {
        if (status === 401) { // 登陆失效
            // history.push('/login');
            // window.location.href = `${location.origin + location.pathname}/#/login`;
            return;
        }
      //  console.error(` XHR request error, the request url is ${url}, message is ${message}`);
        // eslint-disable-next-line
        return Promise.reject({...response.data, message: response.data.message });
    };


    if (status === 200) {


        if (response.config.responseType=="blob") {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = "下载文件"
            if(contentDisposition&&contentDisposition.includes("filename=")){
                fileName=   contentDisposition.split('filename=')[1];

            }
            const decodedFileName = decodeURIComponent(fileName.replace(/['"]/g, ''));

            console.log("-----------文件名字-------------",decodedFileName)

            return  {
                    data:response.data,
                    fileName:decodedFileName
            } ;
        }

        if (success) {
            return response.data;
        }
        return errorCb();
    }
    return errorCb();
}

// 拦截器,response之后
request.interceptors.response.use((response) => {


    return checkResponse(response);
}, (error) => {
    if (error.response) {
        const { status, data, config } = error.response;
        console.error(`
    XHR request error, the request url is ${config.url},
    status is ${status},
    message is ${data.message}`);
        if (status === 401) {
            // history.push('/login');
            // window.location.href = `${window.location.origin}/#/login`;
            return Promise.reject(error.response);
        }
        return Promise.reject(error.response.data);
    }
    return Promise.reject({ message: '服务器错误' });
});

export default request;


// WEBPACK FOOTER //
// ./src/services/request.js